<template>
  <SliderGroup
    v-if="chips.length"
    :items="chips"
    :fog="!isMobile"
    :padding-x="isMobile ? 8 : undefined"
    :class="isMobile ? 'mx-n2' : undefined"
    no-auto-position
  >
    <template #default="{ item, onClick }">
      <MenuChip
        v-if="item.menuChip"
        :item="item"
        :on-click="onClick"
      />
      <MapChip
        v-else-if="item.mapChip"
      />
      <DefaultChip
        v-else
        :item="item"
        :on-click="onClick"
      />
    </template>
  </SliderGroup>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import sortChipsFilters from 'www/vue_components/common/TheFilters/doctors/functions/sortChipsFilters'
import SliderGroup from 'www/vue_components/common/SliderGroup/SliderGroup.vue'
import DefaultChip from 'www/vue_components/common/TheFilters/doctors/components/ChipsFilters/DefaultChip.vue'
import MapChip from 'www/vue_components/common/TheFilters/doctors/components/ChipsFilters/MapChip.vue'
import MenuChip from 'www/vue_components/common/TheFilters/doctors/components/ChipsFilters/MenuChip.vue'
import type { IChip } from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore.types'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const isMobile = window.MOBILE_VERSION

const chips = computed<IChip[]>(() => {
  const isClinic = filtersStore.filters.visitLocation === 'clinic'
  const isHome = filtersStore.filters.visitLocation === 'home'
  const isOnline = filtersStore.filters.visitLocation === 'online'

  return [
    chipsStore.menuChip,
    chipsStore.visitLocationChip,
    chipsStore.patientAgeChip,
    isOnline && chipsStore.cityChip,
    !isHome && chipsStore.priceChip,
    isClinic && chipsStore.dateTodayChip,
    isClinic && chipsStore.dateTomorrowChip,
    isClinic && chipsStore.dateWeekendChip,
    isClinic && chipsStore.dateChip,
    isClinic && chipsStore.placeChip,
    chipsStore.experienceChip,
    chipsStore.genderChip,
    chipsStore.categoryChip,
    chipsStore.scienceChip,
    chipsStore.highRatingChip,
    chipsStore.diseaseChip,
    chipsStore.otherSpecialityChip,
    isClinic && chipsStore.appointmentChip,
    isClinic && chipsStore.clubSwitchChip,
    chipsStore.mapChip,
  ]
    .filter((chip): chip is IChip => Boolean(chip && chip.isVisible))
    .sort(sortChipsFilters)
})
</script>
